import api from '@/services/api';
const ENTITY_ENDPOINT = 'deposito';

export class DepositoService {
  /**
   * Obtiene todos los depositos con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todos los depositos con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Busca depositos por nombre o criterio
   * @param {string} query - Término de búsqueda
   * @param {Object} additionalParams - Parámetros adicionales
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async search(query, additionalParams = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/`, {
      params: {
        Nombre: query,
        ...additionalParams,
      },
    });
  }

  /**
   * Obtiene un deposito por su ID
   * @param {string|number} id - ID del deposito
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea un nuevo deposito
   * @param {Object} deposito - Datos del deposito a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(deposito) {
    return await api.post(`/${ENTITY_ENDPOINT}`, deposito);
  }

  /**
   * Actualiza un deposito existente
   * @param {string|number} id - ID del deposito
   * @param {Object} deposito - Datos del deposito a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, deposito) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, deposito);
  }

  /**
   * Elimina un deposito
   * @param {string|number} id - ID del deposito
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }
}

export default DepositoService;
